/**
 * webpack编译时注入变量
 */
function getEnvVals() {
    var CHANNEL = 'npm';
    try {
        CHANNEL = "npm";
    }
    catch (_a) { }
    var VERSION = '';
    try {
        VERSION = "1.22.4";
    }
    catch (_b) { }
    var BUILD_TIME = '';
    try {
        BUILD_TIME = 1691745197090;
    }
    catch (_c) { }
    var LOCAL_DEV = false;
    try {
        LOCAL_DEV = 0 === '1';
    }
    catch (_d) { }
    var IS_BETA = false;
    try {
        IS_BETA = "0" === '1';
    }
    catch (_e) { }
    return {
        CHANNEL: CHANNEL,
        VERSION: IS_BETA ? "".concat(VERSION, "-beta") : VERSION,
        BUILD_TIME: BUILD_TIME,
        LOCAL_DEV: LOCAL_DEV,
        IS_BETA: IS_BETA,
    };
}
var _a = getEnvVals(), CHANNEL = _a.CHANNEL, BUILD_TIME = _a.BUILD_TIME, VERSION = _a.VERSION, LOCAL_DEV = _a.LOCAL_DEV, IS_BETA = _a.IS_BETA;
export { CHANNEL, BUILD_TIME, VERSION, LOCAL_DEV, IS_BETA };
